export default __webpack_public_path__ + "i18n/translation-vi.989c52fd.json";